var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_965_3264)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.37273 10.2555C6.04298 11.281 5.93023 12.3639 6.04164 13.4353V18.5567C6.04164 20.8334 6.04164 21.9718 6.74609 22.6805C7.38854 23.3229 8.38463 23.3849 10.2683 23.3849V17.3492C10.2683 16.7088 10.5227 16.0946 10.9756 15.6417C11.4285 15.1888 12.0427 14.9344 12.6832 14.9344H16.3054C16.6227 14.9342 16.9368 14.9965 17.23 15.1178C17.5231 15.2391 17.7895 15.4169 18.0139 15.6412C18.2383 15.8654 18.4163 16.1317 18.5377 16.4248C18.6592 16.7179 18.7217 17.032 18.7217 17.3492V23.3863C20.6025 23.3863 21.5986 23.3215 22.2439 22.6819C22.9483 21.9774 22.9483 20.8362 22.9483 18.5581V13.4353C23.0598 12.3639 22.947 11.281 22.6172 10.2555C22.0516 9.33671 21.3007 8.54594 20.4123 7.93362L19.2105 6.89245C16.9563 4.96368 15.8292 4 14.495 4C13.1608 4 12.0294 4.97073 9.77943 6.89245L8.57765 7.93362C7.68934 8.54597 6.9384 9.33674 6.37273 10.2555ZM16.3054 23.3863V17.3492H12.6832V23.3877L16.3054 23.3863Z",
    fill: "#6D57DF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_965_3264"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.f6c50d7ffcf5651b0f87dc35def333cd.svg";
export { ForwardRef as ReactComponent };